import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import httpClient from 'utils/httpClient';

const SEND_CHECK_IN_FILE = (id: Number, courseId: number) =>
  `v2/teacher/course/${courseId}/session/${id}/session-check-in-image`;

export type SendCheckInFileBody = {
  id: number;
  formData: FormData;
  courseId: number;
};

export type SendCheckInFileResponse = {
  sessionCheckInImage: string;
};

export const sendCheckInFile = ({
  id,
  courseId,
  formData,
}: SendCheckInFileBody) =>
  httpClient.post<SendCheckInFileResponse>(
    SEND_CHECK_IN_FILE(id, courseId),
    formData,
    {
      headers: {
        ContentType:
          'multipart/form-data; boundary=----WebKitFormBoundaryRrouvXOkU01wCDJt',
      },
    },
  );

export const useSendCheckInFile = (
  opts?: UseMutationOptions<
    AxiosResponse<SendCheckInFileResponse>,
    AxiosError<any>,
    SendCheckInFileBody
  >,
) =>
  useMutation<
    AxiosResponse<SendCheckInFileResponse>,
    AxiosError<any>,
    SendCheckInFileBody
  >(sendCheckInFile, opts);
